import { GA } from '@phoenix/core/frontend/shared/feature/google-analytics/ga';

const SERVICE_APPOINTMENT_LINK_CLICK_EVENT_NAME = 'mystihl_service_appointment_link_click';
const SERVICE_APPOINTMENT_IMPRESSION_EVENT_NAME = 'mystihl_service_appointment_impression';
const SERVICE_APPOINTMENT_SUBMISSION_EVENT_NAME = 'mystihl_service_appointment_submission';

export type EventData = {
  product_name: string;
  product_id: string;
  product_category?: string;
  from?: string;
  from_url?: string;
};

const event = (name: string, eventData: EventData) => () => GA.sendEvent({ event_name: name, ...eventData });

export const serviceAppointmentLinkClick = (data = {} as EventData) =>
  event(SERVICE_APPOINTMENT_LINK_CLICK_EVENT_NAME, {
    ...data,
    from_url: window?.location?.href,
  });
export const serviceAppointmentImpression = (data = {} as EventData) => event(SERVICE_APPOINTMENT_IMPRESSION_EVENT_NAME, { ...data });
export const serviceAppointmentSubmission = (data = {} as EventData) => event(SERVICE_APPOINTMENT_SUBMISSION_EVENT_NAME, { ...data });
